/* @ngInject */
export default function ResetAttemptsModalControllerService(
  _,
  CurrentCourseManager,
  ConfirmationOverlays,
  AlertMessages,
  QuizModel,
  user,
) {
  class ResetAttemptsModalController {
    constructor() {
      this.CurrentCourseManager = CurrentCourseManager;
      this.QuizModel = QuizModel;
      this.user = user;
      this.resetAttemptsHistoryIsOpen = false;
      this.noActivitiesToReset = false;
      this.loading = false;

      /**
        * @type {
        *   Array.<Object> {
        *     title: string
        *     resetAt: string
        *     resetBy: string
        *   }
        * }
      */
      this.resetList = [];

      /**
        * @type {
        *   {
        *     string: {
        *       id: string
        *       type: string
        *       title: string
        *       hardDeadlinePassed: boolean
        *       attempted: boolean
        *     }
        *   }
        * }
      */
      this.checks = {};

      this.getSubmissions();
    }

    getSubmissions() {
      this.checks = {};
      this.loading = true;
      this.noActivitiesToReset = true;
      QuizModel.getSubmissions(this.CurrentCourseManager.course.catalogId, user.id).then(({ result: { resetList, attempts } }) => {
        this.resetList = resetList;
        _.each(attempts, (attempt) => {
          if (!attempt.hardDeadlinePassed && attempt.attempted) {
            this.noActivitiesToReset = false;
            this.checks[`activity-${attempt.id}`] = { ...attempt, checked: false };
          }
        });
      })
        .finally(() => { this.loading = false; });
    }

    toggleResetAttemptsHistory() {
      this.resetAttemptsHistoryIsOpen = !this.resetAttemptsHistoryIsOpen;
    }

    noSelectedChecks() {
      return !_.some(_.values(this.checks), (attempt) => attempt.checked);
    }

    resetAttempts() {
      const questionSetIds = [];
      _.each(_.values(this.checks), (attempt) => {
        if (attempt.checked) {
          questionSetIds.push(attempt.id);
        }
      });

      const modalInstanceCtrl = ['$scope', ($scope) => {
        $scope.learnerAlias = this.CurrentCourseManager.course.learnersName.downcasedSingularized;
        $scope.pointsAlias = this.CurrentCourseManager.course.pointsName.downcasedPluralized;
      }];

      const modalInstance = ConfirmationOverlays.openConfirmationModal('user_management/templates/reset-attempts-confirm.html', modalInstanceCtrl);
      modalInstance.result.then(() => {
        QuizModel.resetAttempts(this.CurrentCourseManager.course.catalogId, user.id, questionSetIds).then(() => {
          AlertMessages.success('FORM.SUCCESS_BANG', 'USER_MANAGEMENT.RESET_ATTEMPTS_MODAL.RESET_ATTEMPTS_SUCCESS');
          this.getSubmissions();
        }).catch(() => {
          AlertMessages.error('FORM.OOPS', 'FORM.ERROR_SOMETHING_WRONG');
        });
      }).catch(() => {});
    }
  }

  return new ResetAttemptsModalController();
}
